<template>
  <v-dialog v-model="open" persistent max-width="640px">
    <form @submit.prevent="!isProcessing ? onSubmit() : null" novalidate>
    <v-card>
        <v-card-title><span class="headline">Dodawanie użytkownika</span></v-card-title>
        <v-card-text>
          <v-container style="padding-top: 0" grid-list-md>
            <v-layout wrap v-if="!created">
              <v-flex xs12 sm6>
                <v-text-field
                  label="Imię"
                  v-validate="'required'"
                  v-model="formData.name"
                  data-vv-name="imię"
                  :error-messages="errors.collect('imię')"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Nazwisko"
                  v-validate="'required'"
                  v-model="formData.surname"
                  data-vv-name="nazwisko"
                  :error-messages="errors.collect('nazwisko')"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Adres e-mail"
                  v-validate="'required|email'"
                  v-model="formData.email"
                  data-vv-name="email"
                  :error-messages="errors.collect('email')"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  :items="types"
                  label="Typ"
                  item-value="type"
                  item-text="label"
                  data-vv-name="typ"
                  v-model="formData.type"
                  :error-messages="errors.collect('typ')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout wrap v-else>
              <div class="display-flex w-100 justify-content-center">
                <h4>Użytkownik został stworzony!</h4>
              </div>
              <div class="display-flex w-100 justify-content-center">
                Jego hasło to : <strong>{{password}}</strong>
              </div>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="display-flex" v-if="!created">
            <v-btn color="grey darken-1" flat @click="$emit('close'); formData = {}">Anuluj</v-btn>
            <v-btn color="blue darken-1" :disabled="isProcessing" flat type="submit">Zapisz</v-btn>
          </div>
          <div class="display-flex" v-else>
            <v-btn color="grey darken-1" flat @click="$emit('refresh'); formData = {}; password= null; created = false">
              Zamknij
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: 'CreateUser',
    props: {
      open: Boolean,
    },
    data() {
      return {
        types: [{
          label: 'Administrator',
          type: 'A',
        }, {
          label: 'Użytkownik',
          type: 'U',
        }],
        isProcessing: false,
        formData: {},
        created: false,
        password: null,
      };
    },
    methods: {
      ...mapActions('UserStore', ['createUser']),
      onSubmit() {
        this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.isProcessing = true;
              this.createUser(this.formData)
                .then((response) => {
                  this.isProcessing = false;
                  this.created = true;
                  this.password = response;
                }, () => {
                  this.isProcessing = false;
                });
            }
          });
      },
    },
  };
</script>

<style scoped>

</style>
